import { Switch } from '@mui/material';
import { isNotEmptyString, isNotNullOrUndefined } from '@weft/utils';
import type { ChangeEvent, PropsWithChildren } from 'react';
import React from 'react';
import type { FieldPath } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { VyHint } from '../../../../../../components/new-design/data-display/VyHint';
import type { NewPlanForm } from '../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

type ChargeEditDrawerContentItemOptionalProps = PropsWithChildren<{
  fieldPath: FieldPath<PlanInputForm>;
  label: React.ReactNode;
  hint?: string;
  handleOnChecked?: (checked: boolean) => void;
  isChecked?: boolean;
}>;

export const ChargeEditDrawerContentItemOptional: React.FC<ChargeEditDrawerContentItemOptionalProps> = ({ fieldPath, label, hint, handleOnChecked, isChecked, children }) => {
  const { getValues, setValue } = useFormContext<PlanInputForm, NewPlanForm>();
  const doesHaveField = isNotNullOrUndefined(isChecked) ? isChecked : isNotNullOrUndefined(getValues(fieldPath));

  const handleFieldCheck = (_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    isNotNullOrUndefined(handleOnChecked) ? handleOnChecked(checked) : setValue(fieldPath, checked ? '' : undefined, {
      shouldDirty: true,
    });
  };

  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex items-center gap-x-2">
        <Switch
          checked={doesHaveField}
          onChange={handleFieldCheck}
        />
        <label>{ label }</label>

        {isNotEmptyString(hint) && (
          <VyHint
            title={hint}
            className="mb-auto mt-[6px] ml-auto"
          />
        )}
      </div>

      {doesHaveField && (
        children
      )}
    </div>
  );
};